import addEventListenerOnce from '../../../functions/add-event-listener-once'

const passwordStrengthContainer = document.querySelector('.js-password-strength')

if (passwordStrengthContainer) {
  const input = passwordStrengthContainer.querySelector('.js-password-strength-input')
  const hints = passwordStrengthContainer.querySelector('.js-password-strength-hints')
  const meter = passwordStrengthContainer.querySelector('.js-password-strength-meter')
  const requirements = passwordStrengthContainer.querySelectorAll('.js-password-strength-requirement')

  const passwordRequirements = [
    {
      test: (password) => {
        return password.length >= 8
      },
      fulfilled: false
    },
    {
      test: (password) => {
        return /[a-z]/g.test(password)
      },
      fulfilled: false
    },
    {
      test: (password) => {
        return /[A-Z]/g.test(password)
      },
      fulfilled: false
    },
    {
      test: (password) => {
        return /\d/g.test(password)
      },
      fulfilled: false
    },
    {
      test: (password) => {
        return /\W/g.test(password)
      },
      fulfilled: false
    }
  ]

  let passwordScore = 0

  addEventListenerOnce(input, 'focus', function () {
    hints.classList.add('is-active')
  })

  input.addEventListener('input', function () {
    for (let j = 0; j < passwordRequirements.length; j++) {
      if (passwordRequirements[j].test(this.value)) {
        if (!passwordRequirements[j].fulfilled) {
          passwordScore++
        }

        passwordRequirements[j].fulfilled = true

        if (requirements[j]) {
          requirements[j].classList.add('is-fulfilled')
        }
      } else {
        if (passwordRequirements[j].fulfilled) {
          passwordScore--
        }

        passwordRequirements[j].fulfilled = false

        if (requirements[j]) {
          requirements[j].classList.remove('is-fulfilled')
        }
      }
    }

    meter.style.transform = `scaleX(${passwordScore / passwordRequirements.length})`

    if (passwordScore === passwordRequirements.length) {
      meter.classList.add('is-fulfilled')
    } else {
      meter.classList.remove('is-fulfilled')
    }
  })
}
